import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { AdviserComponent }  from './adviser.component';
import { AdvisersComponent } from './advisers.component';
import { AdvisersService }   from './advisers.service';
import { AdvisersStates }    from './advisers.states';
import { SharedModule }      from '../shared/shared.module';
import { TableModule }       from '../table/table.module';

@NgModule({
  declarations: [
    AdviserComponent,
    AdvisersComponent
  ],
  entryComponents: [
    AdviserComponent,
    AdvisersComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: AdvisersStates })
  ],
  providers: [
    AdvisersService
  ]
})
export class AdvisersModule {}
